<mat-drawer-container>
  <div class="button-bar" (click)="drawer.opened ? drawer.close() : onClose()">
    <div class="flex items-center">
      <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close preview"
        class="m-2 ml-4"
        (click)="onClose(); $event.stopPropagation()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="flex items-center">
      @if (type !== "video" && canDownload) {
        <a
          [href]="downloadUrl | secure"
          [download]="downloadFileName"
          (click)="$event.stopPropagation()"
        >
          @if (downloadUrl | secure) {
            <button class="m-2" mat-icon-button aria-label="Download">
              <mat-icon>file_download</mat-icon>
            </button>
          }
        </a>
      }
      @if (type === "video" && !isLoading) {
        <a
          [href]="videoPath | secure"
          [download]="downloadFileName"
          (click)="$event.stopPropagation()"
        >
          <button class="m-2" mat-icon-button aria-label="Download">
            <mat-icon>download</mat-icon>
          </button>
        </a>
      }
      @if (type !== "consent") {
        <button
          (click)="onAction('share'); $event.stopPropagation()"
          class="m-2"
          mat-icon-button
          aria-label="Share"
        >
          <mat-icon>share</mat-icon>
        </button>
      }
      <button
        (click)="drawer.toggle(); $event.stopPropagation()"
        class="m-2"
        mat-icon-button
        aria-label="Show details"
      >
        <mat-icon>info</mat-icon>
      </button>
    </div>
  </div>
  <div class="mid-button-bar">
    @if (content.prev) {
      <button
        mat-icon-button
        aria-label="Previous item"
        (click)="onMovePivot(false)"
      >
        <mat-icon>navigate_before</mat-icon>
      </button>
    }
    @if (content.next) {
      <button
        mat-icon-button
        class="right"
        aria-label="Next item"
        (click)="onMovePivot(true)"
      >
        <mat-icon>navigate_next</mat-icon>
      </button>
    }
  </div>
  <div class="content" (click)="drawer.opened ? drawer.close() : onClose()">
    <div>
      <div class="col content-box px-2 text-center">
        @if (type === "video") {
          <div>
            <div
              class="photo-panel"
              #videoContainer
              style="height: calc(100vh - 237px)"
            >
              @if (videoPath) {
                <video
                  [style.max-width.px]="videoContainer.offsetWidth"
                  [autoplay]="isFromConversation"
                  controls
                  (click)="$event.stopPropagation()"
                  (loadeddata)="isLoading = false"
                  (play)="playing = true"
                  (pause)="playing = false"
                  #videoPlayer
                  id="videoPlayer"
                  [src]="videoPath | secure"
                  [ngClass]="{ 'video-loading': isLoading }"
                >
                  Your browser does not support HTML video.
                </video>
              }
              @if (isLoading) {
                <div class="loading-state">
                  <app-empty-state [isLoading]="true" [message]="' '">
                  </app-empty-state>
                </div>
              }
              @if (!isLoading) {
                <div class="icon">
                  @if (!playing) {
                    <i class="material-icons play appear_1">play_arrow</i>
                  }
                </div>
              }
              <div class="photo-details">
                @if (content.payload.creator) {
                  <div class="cont">
                    @if (content.payload.description) {
                      <div>
                        {{ content.payload.description }}
                      </div>
                    }
                    @if (content.payload.description) {
                      <div class="line"></div>
                    }
                    <div class="taken-by-grid">
                      <div class="left celo-elipsis">
                        @if (content.payload.isImported) {
                          <span> Imported by: </span>
                        }
                        @if (!content.payload.isImported) {
                          <span> Taken by: </span>
                        }
                        <span>
                          {{ content.payload.creator.title }}
                          {{ content.payload.creator.firstName }}
                          {{ content.payload.creator.lastName }}
                        </span>
                      </div>
                      <div class="right">
                        {{ content.payload.createdOn | dateFormat: "medium" }}
                      </div>
                    </div>
                    @if (
                      content.payload.patientData &&
                      content.payload.patientData.uid
                    ) {
                      <div>
                        Patient Details:
                        <span>{{ content.payload.patientData.uid }} </span>
                        @if (content.payload.patientData.firstName) {
                          <span
                            >{{ content.payload.patientData.firstName }}
                          </span>
                        }
                        @if (content.payload.patientData.lastName) {
                          <span
                            >{{ content.payload.patientData.lastName }}
                          </span>
                        }
                        @if (content.payload.patientData.dateOfBirth) {
                          <span
                            >&nbsp;{{
                              content.payload.patientData.dateOfBirth
                                | dateFormat: "dateOfBirth"
                            }}</span
                          >
                        }
                      </div>
                    }
                    <div class="right">
                      {{ content.payload.createdOn | date: "d/M/yyyy h:mm a" }}
                      (NZT)
                    </div>
                  </div>
                }
                @if (mediaList && indexes.length) {
                  <div class="index p-1">
                    <div>{{ indexes.join(",") }} / {{ mediaList.length }}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (type === "photo" && content.payload) {
          <div>
            <div class="photo-panel" style="height: calc(100vh - 237px)">
              <img
                [src]="
                  '/api/v2/media/' +
                    content.payload.id +
                    '?size=Full&' +
                    refreshCount
                    | clink
                    | secure
                "
                class="fh"
                (click)="$event.stopPropagation()"
                (load)="isLoading = false"
                [ngClass]="{
                  'hidden-loading': isLoading,
                  appear_1: !isLoading,
                }"
              />
              @if (isLoading) {
                <div class="loading-state">
                  <app-empty-state [isLoading]="true" [message]="' '">
                  </app-empty-state>
                </div>
              }
              <div class="photo-details">
                @if (content.payload.creator) {
                  <div class="cont">
                    @if (content.payload.description) {
                      <div>
                        {{ content.payload.description }}
                      </div>
                    }
                    @if (content.payload.description) {
                      <div class="line"></div>
                    }
                    <div class="taken-by-grid">
                      <div class="left celo-elipsis">
                        @if (content.payload.isImported) {
                          <span> Imported by: </span>
                        }
                        @if (!content.payload.isImported) {
                          <span> Taken by: </span>
                        }
                        <span>
                          {{ content.payload.creator.title }}
                          {{ content.payload.creator.firstName }}
                          {{ content.payload.creator.lastName }}
                        </span>
                      </div>
                      <div class="right">
                        {{ content.payload.createdOn | dateFormat: "medium" }}
                      </div>
                    </div>
                    @if (
                      content.payload.patientData &&
                      content.payload.patientData.uid
                    ) {
                      <div>
                        Patient Details:
                        <span>{{ content.payload.patientData.uid }} </span>
                        @if (content.payload.patientData.firstName) {
                          <span
                            >{{ content.payload.patientData.firstName }}
                          </span>
                        }
                        @if (content.payload.patientData.lastName) {
                          <span
                            >{{ content.payload.patientData.lastName }}
                          </span>
                        }
                        @if (content.payload.patientData.dateOfBirth) {
                          <span
                            >&nbsp;{{
                              content.payload.patientData.dateOfBirth
                                | dateFormat: "dateOfBirth"
                            }}</span
                          >
                        }
                      </div>
                    }
                  </div>
                }
                @if (mediaList && indexes.length) {
                  <div class="index p-1">
                    <div>{{ indexes.join(",") }} / {{ mediaList.length }}</div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (type === "consent") {
          <div class="pdf-container">
            <pdf-viewer
              [src]="consentSource"
              (click)="$event.stopPropagation()"
              [original-size]="false"
              [autoresize]="true"
              [render-text]="false"
              [zoom]="0.95"
              style="height: 100%"
            ></pdf-viewer>
            @if (isLoading) {
              <div class="loading-state">
                <app-empty-state [isLoading]="true" [message]="' '">
                </app-empty-state>
              </div>
            }
          </div>
        }
        @if (type === "document") {
          <div class="pdf-container">
            <pdf-viewer
              [src]="documentSource"
              (click)="$event.stopPropagation()"
              [original-size]="false"
              [autoresize]="true"
              [render-text]="false"
              [zoom]="0.95"
              style="height: 100%"
            ></pdf-viewer>
            @if (isLoading) {
              <div class="loading-state">
                <app-empty-state [isLoading]="true" [message]="' '">
                </app-empty-state>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <mat-drawer #drawer mode="side" position="end">
    <div class="sidenav-content">
      <div class="sidenav-close">
        <button
          mat-icon-button
          aria-label="Close details"
          (click)="drawer.close()"
        >
          <i class="material-icons-round">close</i>
        </button>
      </div>
      <div>
        <div class="sidenav-title">
          <span class="capitalize">{{ type }}</span> details
        </div>
      </div>
      <div class="scroll-area">
        @if (type === "photo" || type === "video") {
          <app-media-info
            [mediaContainer]="content"
            [userAccount]="userAccount"
            [isFromLibrary]="isFromLibrary"
            [isFromConversation]="isFromConversation"
            [refresh]="photoInfoRefreshCount"
            [exportDisabled]="type === 'video'"
            (deleteClicked)="delete()"
            (needRefresh)="reload()"
          >
          </app-media-info>
        }
        @if (type === "consent" && userAccount) {
          <app-consent-info
            class="p-2"
            [userAccount]="userAccount"
            [consent]="content.payload"
          >
          </app-consent-info>
        }
        @if (type === "document" && document) {
          <app-document-details
            [document]="document"
            [userAccount]="userAccount"
            [isFromLibrary]="isFromLibrary"
            (update)="loadDocumentObject()"
            (deleteClicked)="delete()"
          >
          </app-document-details>
        }
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
